module.exports = __webpack_public_path__ + "img/adhka-yx1zn.002.640f4954.png";